module.exports = __webpack_public_path__ + "img/download.8ca8ff5b.png";